<template>
	<div class="col-12 my-5 pr-4 overflow-auto">
		<div class="d-flex flex-column align-items-center">
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 col-lg-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="date_init"
					>
						DATA INICIAL
					</label>
					<input
						id="date_init"
						ref="date_init"
						type="date"
						class="col-9 form-control"
						v-model="record.date_init"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-6 col-lg-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="time_init"
					>
						HORA INICIAL
					</label>
					<input
						id="time_init"
						ref="time_init"
						type="tel"
						class="col-9 form-control"
						:class="{ 'is-invalid': $v.record.time_init.$error }"
						v-mask="[ '##:##:##' ]"
						placeholder="00:00:00"
						v-model="$v.record.time_init.$model"
						content="Procedimentos que foram <strong>AGENDADOS</strong> não sofrerão nenhuma alteração com esta mudança!"
						v-tippy="{
							allowHTML: true,
							arrow: true, 
							placement : 'bottom' 
						}"
						:disabled="record.isMaterial"
					>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-if="!$v.record.time_init.required">
						A hora inicial é obrigatória.
					</div>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-else-if="!$v.record.time_init.validTime">
						{{ $v.record.time_init.$params.validTime.message }}
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="date_end"
					>
						DATA FINAL
					</label>
					<input
						id="date_end"
						ref="date_end"
						type="date"
						class="col-9 form-control"
						v-model="record.date_end"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-6 col-lg-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="time_end"
					>
						HORA FINAL
					</label>
					<input
						id="time_end"
						ref="time_end"
						type="tel"
						class="col-9 form-control"
						:class="{ 'is-invalid': $v.record.time_end.$error }"
						v-mask="[ '##:##:##' ]"
						placeholder="00:00:00"
						v-model="$v.record.time_end.$model"
						content="Procedimentos que foram <strong>AGENDADOS</strong> não sofrerão nenhuma alteração com esta mudança!"
						v-tippy="{
							allowHTML: true,
							arrow: true, 
							placement : 'bottom' 
						}"
						:disabled="record.isMaterial"
					>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-if="!$v.record.time_end.required">
						A hora final é obrigatória.
					</div>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-else-if="!$v.record.time_end.validTime">
						{{ $v.record.time_end.$params.validTime.message }}
					</div>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="patient_name"
					>
						PACIENTE
					</label>
					<input
						id="patient_name"
						ref="patient_name"
						type="text"
						class="col-9 form-control"
						v-model="record.patient_name"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group position-relative">
					<label
						class="col-3 pl-xl-5"
						for="patient_cpf"
					>
						CPF
					</label>
					<input
						id="patient_cpf"
						ref="patient_cpf"
						type="tel"
						class="col-9 form-control"
						:class="{ 'is-invalid': $v.record.patient_cpf.$error }"
						v-mask="[ '###.###.###-##' ]"
						v-model="$v.record.patient_cpf.$model"
						:disabled="record.isMaterial"
					>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-if="!$v.record.patient_cpf.ValidateDocument">
						O CPF do paciente deve ser válido.
					</div>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="patient_rg"
					>
						RG
					</label>
					<input
						id="patient_rg"
						ref="patient_rg"
						type="text"
						class="col-9 form-control"
						v-model="record.patient_rg"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="patient_rg"
					>
						UF
					</label>
					<select 
						id="patient_rg_uf" 
						ref="patient_rg_uf"
						class="form-control"
						v-model="record.patient_rg_uf"
						:disabled="record.isMaterial"
					>
						<option value="">UF</option>
						<option
							v-for="state in states"
							:key="state.initials"
							:value="state.initials"
						>
							{{ state.initials }}
						</option>
					</select>
				</div>
				<div class="col-12 col-md-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="patient_sus"
					>
						CNS
					</label>
					<input
						id="patient_sus"
						ref="patient_sus"
						type="tel"
						class="col-9 form-control"
						v-model="record.patient_sus"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-3 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="patient_rh"
					>
						RH
					</label>
					<input
						id="patient_rh"
						ref="patient_rh"
						type="tel"
						class="col-9 form-control"
						v-model="record.patient_rh"
						:disabled="record.isMaterial"
					>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="module_name"
					>
						MÓDULO
					</label>
					<input
						id="module_name"
						ref="module_name"
						type="text"
						class="col-9 form-control"
						v-model="record.module_name"
						disabled
					>
				</div>
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="modality_name"
					>
						MODALIDADE
					</label>
					<input
						id="modality_name"
						ref="modality_name"
						type="text"
						class="col-9 form-control"
						v-model="record.modality_name"
						disabled
					>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 col-lg-6 col-xxl-4 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="origin"
					>
						ORIGEM
					</label>
					<input
						id="origin"
						ref="origin"
						type="text"
						class="col-9 form-control"
						v-model="record.origin"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-6 col-lg-6 col-xxl-4 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="partnership_name"
					>
						CONVÊNIO
					</label>
					<input
						id="partnership_name"
						ref="partnership_name"
						type="text"
						class="col-9 form-control"
						v-model="record.partnership_name"
					>
				</div>
				<div class="col-12 col-md-12 col-lg-12 col-xxl-4 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="authorization"
					>
						AUTORIZAÇÃO
					</label>
					<input
						id="authorization"
						ref="authorization"
						type="text"
						class="col-9 form-control"
						v-model="record.authorization"
						:disabled="record.isMaterial"
					>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="predicted_item"
					>
						ITEM PREVISTO
					</label>
					<input
						id="predicted_item"
						ref="predicted_item"
						type="text"
						class="col-9 form-control"
						v-model="record.predicted_item"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="predicted_item_code"
					>
						CÓD. ITEM PREVISTO
					</label>
					<input
						id="predicted_item_code"
						ref="predicted_item_code"
						type="tel"
						class="col-9 form-control"
						v-model="record.predicted_item_code"
						:disabled="record.isMaterial"
					>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="released_item"
					>
						ITEM EXECUTADO
					</label>
					<input
						id="released_item"
						ref="released_item"
						type="text"
						class="col-9 form-control"
						v-model="record.released_item"
					>
				</div>
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="released_internal_code"
					>
						CÓD. ITEM EXECUTADO
					</label>
					<input
						id="released_internal_code"
						ref="released_internal_code"
						type="tel"
						class="col-9 form-control"
						v-model="record.released_internal_code"
					>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 col-xxl-4 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="unit"
					>
						UNIDADE
					</label>
					<input
						id="unit"
						ref="unit"
						type="tel"
						class="col-9 form-control"
						v-model="record.unit"
						:disabled="!record.isMaterial"
					/>
				</div>
				<div class="col-12 col-md-6 col-xxl-4 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="unity_value"
					>
						VALOR UNITÁRIO
					</label>
					<MoneyInput
						id="unity_value"
						ref="unity_value"
						custom_class="col form-control"
						v-model="record.unity_value"
						:disabled="!record.isMaterial"
					/>
				</div>
				<div class="col-12 col-md-6 col-xxl-4 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="quantity"
					>
						QUANTIDADE
					</label>
					<input
						id="quantity"
						ref="quantity"
						type="tel"
						class="col-9 form-control"
						v-model="record.quantity"
						:disabled="!record.isMaterial"
					/>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="factor"
					>
						FATOR DE REDUÇÃO OU ACRÉSCIMO
					</label>
					<input
						id="factor"
						ref="factor"
						type="tel"
						class="col-9 form-control"
						:value="formattedFactor"
						inputmode="decimal"
						@input="UpdateFactor"
					/>
				</div>
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="proceeding_value"
					>
						VALOR
					</label>
					<MoneyInput
						id="proceeding_value"
						ref="proceeding_value"
						custom_class="col-9 form-control"
						v-model="record.proceeding_value"
					/>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-2 flex-wrap">
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="aliquot_value"
					>
						ALÍQUOTA
					</label>
					<MoneyInput
						id="aliquot_value"
						ref="aliquot_value"
						custom_class="col-9 form-control"
						v-model="record.aliquot_value"
					/>
				</div>
				<div class="col-12 col-md-6 px-0 mb-2 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="honorary_value"
					>
						HONORÁRIO
					</label>
					<MoneyInput
						id="honorary_value"
						ref="honorary_value"
						custom_class="col-9 form-control"
						v-model="record.honorary_value"
					/>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-3">
				<div class="col px-0 mb-0 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="payment_money"
					>
						PG. DINHEIRO
					</label>
					<MoneyInput
						id="payment_money"
						ref="payment_money"
						custom_class="col-9 form-control"
						v-model="record.payment_money"
						:disabled="record.isMaterial"
					/>
				</div>
				<div class="col px-0 mb-0 ml-3 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="payment_pix"
					>
						PG. PIX
					</label>
					<MoneyInput
						id="payment_pix"
						ref="payment_pix"
						custom_class="col-9 form-control"
						v-model="record.payment_pix"
						:disabled="record.isMaterial"
					/>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-3">
				<div class="col px-0 mb-0 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="payment_debit"
					>
						PG. DÉBITO
					</label>
					<MoneyInput
						id="payment_debit"
						ref="payment_debit"
						custom_class="col-9 form-control"
						v-model="record.payment_debit"
						:disabled="record.isMaterial"
					/>
				</div>
				<div class="col px-0 mb-0 ml-3 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="payment_credit"
					>
						PG. CRÉDITO
					</label>
					<MoneyInput
						id="payment_credit"
						ref="payment_credit"
						custom_class="col-9 form-control"
						v-model="record.payment_credit"
						:disabled="record.isMaterial"
					/>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-3">
				<div class="col px-0 mb-0 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="discount"
					>
						DESCONTO
					</label>
					<MoneyInput
						id="discount"
						ref="discount"
						custom_class="col form-control"
						v-model="record.discount"
						:disabled="record.isMaterial"
					/>
				</div>
				<div class="col px-0 mb-0 ml-3 d-flex align-items-center form-group">
					<label
						class="col-3 pl-xl-5"
						for="indicator"
					>
						SOLICITANTE
					</label>
					<input
						id="indicator"
						ref="indicator"
						type="tel"
						class="col-9 form-control"
						v-model="record.indicator"
						:disabled="record.isMaterial"
					>
				</div>
			</div>
			<div class="col-12 px-0 d-flex align-items-center my-3">
				<div class="col px-0 mb-0 d-flex align-items-center form-group">
					<label
						class="col-3"
						for="user_name"
					>
						AUTOR
					</label>
					<input
						id="user_name"
						ref="user_name"
						type="text"
						class="col-9 form-control"
						v-model="record.user_name"
						:disabled="record.isMaterial"
					>
				</div>
				<div class="col px-0 mb-0 ml-3 d-flex align-items-center form-group position-relative">
					<label
						class="col-3 pl-xl-5"
						for="document_user"
					>
						IDENT. AUTOR
					</label>
					<input
						id="document_user"
						ref="document_user"
						type="tel"
						class="col-9 form-control"
						:class="{ 'is-invalid': $v.record.document_user.$error }"
						v-mask="[ '###.###.###-##' ]"
						v-model="$v.record.document_user.$model"
						:disabled="record.isMaterial"
					>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-if="!$v.record.document_user.required">
						A indentificação do autor é obrigatória.
					</div>
					<div class="position-absolute ps-b--4 ps-l-3 invalid-feedback" v-else-if="!$v.record.document_user.ValidateDocument">
						A indentificação do autor deve ser válida.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash'
import MoneyInput from '../../shared/MoneyInput.vue'
import { helpers, required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'

const validTime = helpers.withParams(
	{ message: 'O valor de hora deve ser válido no formato HH:MM:SS.' },
	(value) => {
		if (!value) return false;
		const timeParts = value.split(':');
		if (timeParts.length !== 3) return false;

		const hours = parseInt(timeParts[0], 10);
		const minutes = parseInt(timeParts[1], 10);
		const seconds = parseInt(timeParts[2], 10);

		return (
		hours >= 0 && hours < 24 &&
		minutes >= 0 && minutes < 60 &&
		seconds >= 0 && seconds < 60
		);
	}
)

const ValidateDocument = (value, vm) => {
	if(value) {
		let ret 		= false
		let cpf 		= value

		if(cpf == null || cpf == '') {
			ret 	= true
		} else if(cpf != null && cpf.length < 14) {
			ret 	= false
		} else if(cpf != null && cpf.length == 14) {
			ret 	= window.helpers.ValidaCPF(cpf)
		}

		return ret
	}

	return true
}

export default {
	name: 'RecordForm',
	components: {
		MoneyInput
	},
	props: {
		props_record: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			states: window.statesBR,
			record: {
				date_init: null,
				time_init: null,
				date_end: null,
				time_end: null,
				patient_name: null,
				patient_cpf: null,
				patient_rg: null,
				patient_rg_uf: null,
				patient_sus: null,
				patient_rh: null,
				module_name: null,
				modality_name: null,
				origin: null,
				partnership_name: null,
				indicator: null,
				user_name: null,
				document_user: null,
				predicted_item: null,
				predicted_item_code: null,
				released_item: null,
				released_internal_code: null,
				authorization: null,
				factor: null,
				proceeding_value: 0.00,
				aliquot_value: 0.00,
				honorary_value: 0.00,
				payment_money: 0.00,
				payment_pix: 0.00,
				payment_credit: 0.00,
				payment_debit: 0.00,
				discount: 0.00,
				unit: null,
				unity_value: 0.00,
				quantity: 0
			}
		}
	},
	computed: {
		formattedFactor() {
			return this.NormalizeFactor(this.record.factor).replace('.', ',')
		}
	},
	validations() {
		return {
			record: {
				time_init: {
					required,
					validTime
				},
				time_end: {
					required,
					validTime
				},
				patient_cpf: {
					ValidateDocument
				},
				document_user: {
					required,
					ValidateDocument
				}
			}
		}
	},
	watch: {
		props_record: {
			handler(val) {
				if(!_.isEmpty(val)) {
					for (const [ key, value ] of Object.entries(val)) {
						this.record[key] = value == '-' ? null : value
					}

					this.SanitizeRecordData()
				}
			},
			immediate: true
		},
		'record.patient_name': {
			handler(val) {
				if(val != null) {
					this.record.patient_name = window.helpers.RemoveAcento(val).toUpperCase()
				}
			}
		}
	},
	methods: {
		NormalizeFactor(value) {
			const number = Number(String(value ?? '').replace(',', '.'))
			return Number.isFinite(number) && number >= 0.01 && number <= 9.99
				? number.toFixed(2)
				: '1.00'
		},
		UpdateFactor(event) {
			const digits = event.target.value.replace(/\D/g, '').slice(-3)
			this.record.factor = this.NormalizeFactor(Number(digits) / 100)
			event.target.value = this.formattedFactor
		},
		SanitizeRecordData() {
			this.record.factor = this.NormalizeFactor(this.record.factor)

			this.record.date_init = moment(this.record.date_init, 'DD/MM/YYYY').format('YYYY-MM-DD')
			this.record.date_end = moment(this.record.date_end, 'DD/MM/YYYY').format('YYYY-MM-DD')

			this.record.proceeding_value = Number(this.record.proceeding_value.replace(',', '.'))
			this.record.aliquot_value = Number(this.record.aliquot_value.replace(',', '.'))
			this.record.honorary_value = Number(this.record.honorary_value.replace(',', '.'))
			this.record.payment_money = Number(this.record.payment_money.replace(',', '.'))
			this.record.payment_pix = Number(this.record.payment_pix.replace(',', '.'))
			this.record.payment_credit = Number(this.record.payment_credit.replace(',', '.'))
			this.record.payment_debit = Number(this.record.payment_debit.replace(',', '.'))
			this.record.discount = Number(this.record.discount.replace(',', '.'))
			this.record.unity_value = Number(this.record.unity_value.replace(',', '.'))

			if(this.record.patient_rg && this.record.patient_rg_uf) {
				this.record.patient_rg_uf = this.record.patient_rg.match(/[^0-9]{2}$/)[0]
				this.record.patient_rg = this.record.patient_rg.replace(/[^0-9]/g, '')
			}
		},
		isMaterial(record) {
			return record.isMaterial && record.isMaterial === true ? true : false
		}
	}
}
</script>

<style lang="scss" scoped>
	.hr-width {
		width: 100%
	}

	.gap-5 {
		gap: 1.25rem;
	}

	::v-deep .form-control:disabled, .form-control[readonly] {
		background-color: var(--disabledBackgroundColor);
		border-color: var(--disabledBackgroundColor) !important;
    	color: var(--disabledColor) !important;
	}
</style>